<template>
  <section class="content" id="marketplace">
    <div class="box box-primary">
      <div class="box-header with-border">
        <h3 class="box-title">
          <i class="fa fa-wrench mr-5"></i>
          {{ 'marketplace_settings' | translate }}
        </h3>
      </div>
    </div>
    <div v-for="(marketplace, index) in this.marketplaces" class="box box-solid collapsed-box">
      <div class="box-header no-border">
        <h3 class="box-title">{{ marketplace.label}}</h3>
        <div class="box-tools pull-right" title="Details einblenden">
          <button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-plus"></i></button>
        </div>
      </div>
      <div class="box-body" style="display: none;">
        <table class="table table-hover">
          <thead>
          <tr v-if="marketplace.config !== null">
            <th>#</th>
            <th>{{'priceModel' | translate}}</th>
            <th v-if="marketplace.config.id === 'connect2'">{{'stockPercentage' | translate}}</th>
            <th v-if="marketplace.config.id === 'connect2'">{{'type' | translate}}</th>
            <th v-if="marketplace.config.id !== 'connect2' && marketplace.config.id !== undefined">{{'stock' | translate}}</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <tr v-if="marketplace.config !== null">
              <td>{{marketplace.id}}</td>
              <td>{{marketplace.config.id | translate}}</td>
              <td v-if="marketplace.config.id === 'connect2'">{{marketplace.config.stockPercentage}}</td>
              <td v-if="marketplace.config.id === 'connect2'">{{marketplace.config.type}}</td>
              <td v-if="marketplace.config.id !== 'connect2'">{{marketplace.config.stock}}</td>
              <td>
                <button
                  class="btn btn-flat btn-info mb-10 mt-10"
                  data-toggle="modal"
                  data-target="#priceModelConfigModal"
                  @click="openPriceModelConfigModal(marketplace)">
                  <i class="fa fa-wrench mr-5"></i>
                  {{'edit'|translate}}
                </button>
              </td>
            </tr>
            <tr v-else>
              <td>{{marketplace.id}}</td>
              <td>
                <button
                  class="btn btn-flat btn-info mb-10 mt-10"
                  data-toggle="modal"
                  data-target="#priceModelConfigModal"
                  @click="openPriceModelConfigModal(marketplace)">
                  <i class="fa fa-wrench mr-5"></i>
                  {{'edit'|translate}}
                </button>
              </td>
            </tr>
          </tr>
          </tbody>
        </table>
      </div>
   </div>
    <PriceModelConfigModal id="priceModelConfigModal" :modelConfig="modelConfig" :modelRefreshConfig="modelRefreshConfig"></PriceModelConfigModal>
  </section>
</template>

<script>
export default {
  data() {
    return {
      marketplaces: [],
      modelConfig: {
        label: '',
        id: 0,
        config: {
          id: '',
          type: '',
          stockPercentage: 0
        }
      },
      modelRefreshConfig: {}
    }
  },
  methods: {
    openPriceModelConfigModal(model) {
      this.modelRefreshConfig = model
      if (model.config == null) {
        model.config = {
          id: 'connect2',
          type: 'lowest',
          stockPercentage: 0
        }
      }
      this.modelConfig = JSON.parse(JSON.stringify(model));
    }
  },
  computed: {},
  mounted() {
    API.get('marketplaces')
      .then(res => {
        this.marketplaces = res.data
      })
  }
}
</script>

<style>
#marketplace .btn {
  float: right;
}

#marketplace th {
  width: 20rem;
}

.overlay {
  z-index: 50;
  background: rgba(33, 34, 40, .75);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 110%;
}

.overlay > .fa {
  position: absolute;
  top: 50%;
  left: 50%;
  margin-left: -1rem;
  margin-top: -1rem;
  color: currentColor;
  font-size: 2rem;
  opacity: 0.65;
}

.min-width-45 {
  min-width: 45%;
}
</style>
<style scoped>
.loading-gif {
  display: block;
  width: 5%;
  top: 42%;
  left: 50%;
  position: fixed;
}
</style>



// WEBPACK FOOTER //
// src/components/views/PriceModelSettings.vue